export const DraftsActionTypes = {
  REQUEST_DRAFTS: 'zola/card/card_project/REQUEST_DRAFTS',
  RECEIVE_DRAFTS: 'zola/card/card_project/RECEIVE_DRAFTS',
  RECEIVE_DELETE_PROJECT: 'zola/cards/card_project/RECEIVE_DELETE_PROJECT',
  RESET_DRAFT_IN_CART_WARNING: 'zola/cards/card_project/RESET_DRAFT_IN_CART_WARNING',
  SET_DRAFT_IN_CART_WARNING: 'zola/cards/card_project/SET_DRAFT_IN_CART_WARNING',
};

export default DraftsActionTypes;
